import { createNavigationContainerRef, DrawerActions } from '@react-navigation/native';
import { getDrawerStatusFromState } from '@react-navigation/drawer';
import React from 'react';
export { useDrawerStatus } from '@react-navigation/drawer';


class NavigationService {
    ref = createNavigationContainerRef();
    drawerOpenStatus = React.createRef("closed");

    get drawerStatus () {
        return this.drawerOpenStatus.current;
    }

    set drawerStatus (drawerOpenStatus) {
        this.drawerOpenStatus.current = drawerOpenStatus;
    }

    state = null;

    // navigate(name, params) {
    //     if(!this._isNavigationReady()) return;
    //     this.ref.navigate(name, params);
    // }

    isDrawerForceClosed = false;
    setForceCloseDrawer(isDrawerForceClosed) {
        this.isDrawerForceClosed = isDrawerForceClosed;
        if (isDrawerForceClosed) {
            this.closeDrawer();
        }
    }

    getState() {
        return this.state;
    }

    setState(state) {
        this.state = state;
    }

    openDrawer() {
        if(!this._isNavigationReady()) return;
        if(this.isDrawerForceClosed) return;
        this.ref.dispatch(DrawerActions.openDrawer());
    }


    closeDrawer() {
        if(!this._isNavigationReady()) return;
        this.ref.dispatch(DrawerActions.closeDrawer());
    }

    isDrawerOpen () {
        if (!this.getState()) return false;
        return getDrawerStatusFromState(this.getState()) === 'open';
    }

    _isNavigationReady() {
        return this.ref.isReady();
    }
}


export const navigationService  = new NavigationService()